import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const enabledFlagOptionsSelector = ({ administration }) =>
  administration[adminPageNames.TAX_RATES].enabledFlagValues;

export const countryCodeOptionsSelector = ({ administration }) =>
  administration[adminPageNames.TAX_RATES].countryCodes;

export const plAccountOptionsSelector = ({ administration }) => (
  administration[adminPageNames.TAX_RATES].plAccountValues
);

export const bsAccountOptionsSelector = ({ administration }) => (
  administration[adminPageNames.TAX_RATES].bsAccountValues
);

export const defPlAccountOptionsSelector = ({ administration }) => (
  administration[adminPageNames.TAX_RATES].plAccountValues
);

export const defBsAccountOptionsSelector = ({ administration }) => (
  administration[adminPageNames.TAX_RATES].bsAccountValues
);

export const sharedSelectors = getSelectors(adminPageNames.TAX_RATES);

export const isFetchingInitialDataForAddAndEditModalSelector = ({ administration }) => (
  administration[adminPageNames.TAX_RATES].isFetchingInitialDataForAddEditModal
);
